import { useDispatch, useSelector } from 'react-redux'

import { useEnforceUpgrade } from 'components/billing/useEnforceUpgrade'
import { isAvailableFeatureSelector } from 'features/billing'

import { ManagedEventsPopup } from './managed_events_popup'
import {
  isOpenSelector,
  isSlugConflictOpenSelector,
  membershipIdsSelector,
} from './selectors'
import { applyManagedEvents } from './slice'
import { SlugConflictPopup } from './slug_conflict_popup'

export const ApplyManagedEventsPopup = () => {
  const dispatch = useDispatch()
  const isOpen = useSelector(isOpenSelector)
  const isSlugConflictOpen = useSelector(isSlugConflictOpenSelector)
  const membershipIds = useSelector(membershipIdsSelector)
  const enforceUpgrade = useEnforceUpgrade('managed_events')
  const isManagedEventsFeatureAvailable = useSelector((state) => isAvailableFeatureSelector(state, { featureKey: 'managed_events' }))

  const submit = () => {
    if (!isManagedEventsFeatureAvailable) {
      enforceUpgrade()
    } else {
      dispatch(applyManagedEvents({ membershipIds, checkSlugConflicts: true }))
    }
  }

  const forceSubmit = () => {
    dispatch(applyManagedEvents({ membershipIds, checkSlugConflicts: false }))
  }

  return (
    <>
      <ManagedEventsPopup
        isOpen={isOpen}
        onSubmit={submit}
      />
      <SlugConflictPopup
        isOpen={isSlugConflictOpen}
        onSubmit={forceSubmit}
      />
    </>
  )
}
